import { useAppDispatch, useAppSelector } from '@/app/hooks';
import type { RootState } from '@/app/store';
import AuthLayout from '@/components/common/AuthLayout';
import { Button } from '@/components/ui/button';
import type { Workspace } from '@/features/workspace/types';
import { setCurrentWorkspace } from '@/features/workspace/workspaceSlice';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

const InviteToWorkspacePage = () => {
  const { t } = useTranslation('auth');
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const workspaceId = params.get('wp');
  const workspace = useAppSelector((s: RootState) =>
    s.workspace.workspacesList?.find(
      (workspace) => workspace.id === Number.parseInt(workspaceId ?? '0'),
    ),
  );
  const loading = useAppSelector((s: RootState) => s.workspace.loading);
  const handleSelect = (workspace: Workspace) => {
    dispatch(setCurrentWorkspace({ ...workspace }));
    navigate('/', { replace: true });
  };
  return (
    <AuthLayout title={t('inviteToWorkspace.title')} background="gradient">
      <div className="space-y-4">
        {workspace ? (
          <>
            <p>{t('inviteToWorkspace.subtitle', { workspaceName: workspace.name })}</p>
            <Button disabled={loading} onClick={() => handleSelect(workspace as Workspace)}>
              {loading && <Loader2 className="size-4 animate-spin" />}{' '}
              {t('inviteToWorkspace.select')}
            </Button>
          </>
        ) : (
          <p>{t('inviteToWorkspace.noWorkspace')}</p>
        )}
      </div>
    </AuthLayout>
  );
};

export default InviteToWorkspacePage;
